import React from 'react';
import styles from '../app.module.css'

const FormTextarea = ({ label, value, onChange }) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <textarea value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
};

export default FormTextarea;
